module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_5012.54fac566.png";